import { stripPathLocale } from '../../common/localeShared';

export function getTrackedInternalLinkUrl(to: string, origin: string = window.location.origin) {
  const url = new URL(to, origin);

  if (url.origin === origin) {
    url.pathname = stripPathLocale(url.pathname);
  }

  return url.toString();
}
